import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MessageCircle, PawPrint, Calendar } from 'lucide-react';
import { Button } from './ui/button';
import { CONTACT } from '../data/mock';
import { trackCallClick, trackWhatsAppClick, trackBookButtonClick } from '../lib/analytics';

const CTABanner = ({
  title = 'Ready to give your pet the love they deserve?',
  subtitle = 'Book an appointment, chat on WhatsApp, or speak directly to a pet care expert.',
  variant = 'gradient',
}) => {
  const isDark = variant === 'gradient';

  return (
    <section className={`relative overflow-hidden ${isDark ? 'bg-gradient-to-br from-[#1a0b3d] via-[#2a1456] to-[#5b3eb5]' : 'bg-white'}`}>
      <PawPrint className={`absolute top-8 right-12 w-24 h-24 ${isDark ? 'text-white/10' : 'text-[#f3d6f5]/40'}`} />
      <PawPrint className={`absolute bottom-8 left-12 w-32 h-32 rotate-12 ${isDark ? 'text-white/10' : 'text-[#f3d6f5]/40'}`} />

      <div className="relative max-w-[1200px] mx-auto px-5 lg:px-10 py-16 lg:py-24 text-center">
        <h2 className={`font-serif text-[36px] lg:text-[52px] font-extrabold leading-[1.1] mb-5 max-w-3xl mx-auto ${isDark ? 'text-white' : 'text-[#1a0b3d]'}`}>
          {title}
        </h2>
        <p className={`text-[17px] lg:text-[19px] mb-10 max-w-2xl mx-auto ${isDark ? 'text-white/80' : 'text-slate-600'}`}>
          {subtitle}
        </p>

        <div className="flex flex-wrap justify-center gap-3 lg:gap-4">
          <Link to="/book" onClick={() => trackBookButtonClick('cta_banner')}>
            <Button
              className={`rounded-full px-7 py-7 h-auto text-[15px] font-semibold gap-2 shadow-lg hover:shadow-2xl hover:scale-105 transition-all ${
                isDark
                  ? 'bg-white text-[#5b3eb5] hover:bg-[#f3d6f5]'
                  : 'bg-[#5b3eb5] hover:bg-[#4a31a3] text-white'
              }`}
            >
              <Calendar size={18} /> Book An Appointment
            </Button>
          </Link>

          <a
            href={`https://wa.me/${CONTACT.phoneRaw.replace('+', '')}`}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackWhatsAppClick('cta_banner')}
          >
            <Button
              className="rounded-full px-7 py-7 h-auto text-[15px] font-semibold gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-lg hover:shadow-2xl hover:scale-105 transition-all"
            >
              <MessageCircle size={18} /> Chat on WhatsApp
            </Button>
          </a>

          <a href={`tel:${CONTACT.phoneRaw}`} onClick={() => trackCallClick('cta_banner')}>
            <Button
              variant="outline"
              className={`rounded-full px-7 py-7 h-auto text-[15px] font-semibold gap-2 ${
                isDark
                  ? 'border-white/40 bg-white/10 text-white hover:bg-white hover:text-[#5b3eb5] backdrop-blur'
                  : 'border-[#5b3eb5] text-[#5b3eb5] hover:bg-[#5b3eb5] hover:text-white'
              }`}
            >
              <Phone size={18} /> Speak to an Expert
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
